import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useShifts(oppositionId) {
    return useQuery({
        queryKey: ['shifts', oppositionId ?? 'all'],
        queryFn: () => {
            const qs = oppositionId ? `?opposition_id=${encodeURIComponent(oppositionId)}` : '';
            return apiClient(`/shifts${qs}`);
        },
        staleTime: 1000 * 60 * 5,
    });
}
export function useCreateShift() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/shifts', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['shifts'] }),
    });
}
export function useUpdateShift() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, ...rest }) => apiClient(`/shifts/${id}`, { method: 'PATCH', body: JSON.stringify(rest) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['shifts'] }),
    });
}
export function useDeleteShift() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/shifts/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['shifts'] }),
    });
}
//# sourceMappingURL=useShifts.js.map